<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="dialog_title">
          <span>{{title}}</span>
        </v-card-title>
      
        <v-card-text class="mt-4">{{msg}}</v-card-text>

        <v-divider class="ma-0"></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn color="secondary" text @click="onCancel()">{{noText}}</v-btn>
          <v-btn color="primary" class="right" text @click="onConfirm()">{{yesText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "confirm",

  props: {
    yesText: {
      default: "Yes"
    },
    dialog: {
      default: false
    },
    noText: {
      default: "No"
    },
    title: {
      default: "Are you sure?"
    },
    msg: {
      default: ""
    },
    load: {
      default: true
    }
  },
  methods: {
    onConfirm() {
      this.$emit("onConfirm");
    },
    onCancel() {
      this.$emit("onCancel");
    }
  }
};
</script>